import { Button, Form, message, Modal, Upload } from "antd";
import { InboxOutlined, PlusOutlined } from "@ant-design/icons";
import { useState } from "react";
import {useArrearDocumentUploader} from "../../../hooks/useArrearDocumentUploader";

const { Dragger } = Upload;

export const CreateArrearModal = () => {
  const [form] = Form.useForm();
  const [upload, { isLoading }] = useArrearDocumentUploader();
  const files = Form.useWatch("files", form);

  const [open, setOpen] = useState(false);
  return (
    <>
      <Modal
        title={"Aggiungi arretrato"}
        open={open}
        onCancel={() => {
          form.resetFields();
          setOpen(false);
        }}
        okText={"Aggiungi"}
        onOk={() => {
          form.validateFields().then((values) => {
            console.log("values: ", values);
            upload(values.files[0].originFileObj)
              .then(() => {
                message.success("Documento salvato");
                form.resetFields();
                setOpen(false);
              }).catch((err) => {
              console.error(err);
              message.error(err);
            });
          }).catch(err => {
            console.error("validation error", err);
          });
        }}
        okButtonProps={{ disabled: isLoading || !files?.length, loading: isLoading }}>
        <Form form={form} layout={"vertical"}>
          <Form.Item
            name={"files"}
            label={"Carica file"}
            valuePropName={"fileList"}
            getValueFromEvent={(e) => e.fileList}
            rules={[
              {
                required: true,
                message:
                  "I documenti di cui effettuare l'estrazione sono obbligatori"
              }
            ]}
          >
            <Dragger
              beforeUpload={() => false}
              multiple={false}
              accept={".xls,.xlsx"}
              maxCount={1}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Trascina il file qui o clicca per caricare
              </p>
              <p className="ant-upload-hint">
                Supporta solo file .xls,.xlsx
              </p>
            </Dragger>
          </Form.Item>
        </Form>
      </Modal>
      <Button type={"link"} icon={<PlusOutlined />} onClick={() => setOpen(true)}>Aggiungi arretrato</Button>
    </>
  );
};